import { render } from "./flowForm.vue?vue&type=template&id=0c44f640&scoped=true"
import script from "./flowForm.vue?vue&type=script&lang=js"
export * from "./flowForm.vue?vue&type=script&lang=js"

import "./flowForm.vue?vue&type=style&index=0&id=0c44f640&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c44f640"]])

export default __exports__